import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { Tariff } from '../models/tariff.model';
import { ResponsePackage } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class TariffService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient, private config: AppConfig) {
    this.pathApi = this.config.setting['pathApi'] + 'tariff/';
  }

    public getAllForSelect(utilityId: number | null = null) {
    if(utilityId) {
      return this.http.get<ResponsePackage<Tariff[]>>(`${this.pathApi}getAllForSelect/${utilityId}`,{headers: this.headers, observe: 'response'});
    }
    else {
      return this.http.get<ResponsePackage<Tariff[]>>(`${this.pathApi}getAllForSelect`,{headers: this.headers, observe: 'response'});
    }
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  save(tariff: Tariff): Observable<any> {
    return this.http.post(`${this.pathApi}save`, tariff, {
      observe: 'response',
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, {
      observe: 'response',
    });
  }
}
